import { Row, Table } from "antd";
import { Header } from "./components/Header";
import { useFetchCount } from "./hooks/useFetchCount";
import { useFetchData } from "../../lib/hooks/useDefaultFetchData";
import MailingsService from "../../services/mailings";
import { useCallback, useMemo, useState } from "react";
import { useTableColumns } from "./hooks/useTableCoumns";
import { TablePagination } from "../../components/TablePagination";
import { Email } from "../../types/Email";
import { useDefualtOnRow } from "../../lib/hooks/useDefaultOnRow";
import { EmailModal } from "../../components/EmailModal";
import "./styles.scss";
import MAILING_PAGES from "../../types/enums/MailingPages";

export const Emails = () => {
  const { total, isLoading: isCountLoading, request, setRequest, fetchCount, onPageChange } = useFetchCount();

  const [id, setId] = useState<string | null>(null);

  const { data, isLoading, fetchData, setData } = useFetchData<any, Email>(
    MailingsService,
    request,
    ".clickable-rows-table"
  );

  const reloadData = useCallback((): void => {
    fetchCount();
    fetchData();
  }, [fetchCount, fetchData]);

  const { columns } = useTableColumns(request.page, reloadData, setId);

  const isAllLoading: boolean = useMemo(() => isCountLoading && isLoading, [isCountLoading, isLoading]);

  const { onRow } = useDefualtOnRow(setId);

  const close = useCallback(() => setId(null), []);

  const mailingType: 3 | 1 = useMemo(
    () => ([MAILING_PAGES.Scheduled, MAILING_PAGES.Recurring].includes(request.page) ? 3 : 1),
    [request]
  );

  return (
    <Row className="table-page-content emails">
      <Header
        request={request}
        setRequest={setRequest}
        isLoading={isAllLoading}
        reloadData={reloadData}
        setData={setData}
      />
      <Row className="d-block table__container w-100 mx-8 mt-4">
        <Table
          dataSource={data}
          columns={columns}
          loading={isLoading}
          pagination={false}
          className="overflow-y-auto clickable-rows-table"
          rowKey={"id"}
          onRow={onRow}
        />
        <TablePagination
          isTotalLoading={isCountLoading}
          total={total}
          currentPage={request.pageNumber}
          pageSize={request.pageSize}
          onPageChange={onPageChange}
        />
      </Row>
      <EmailModal id={id} close={close} mailingType={mailingType} shouldOpen={!!id} reloadData={reloadData} />
    </Row>
  );
};
